module.exports = __webpack_public_path__ + "static/media/c.3eeaad17.svg";